import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-contact-form',
  templateUrl: './email-contact-form.component.html',
  styleUrls: ['./email-contact-form.component.css','../../admin.css']
})
export class EmailContactFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/email/contact-form/email-contact-form.component.ts